import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Shared';
import { useApply } from './ApplyContext';
export const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    open
  } = useApply();
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-245">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-navy/95 backdrop-blur-md border-t border-gold/20 z-50 md:hidden" data-id="element-246">
          <Button onClick={open} variant="solid" className="w-full shadow-lg" data-id="element-247">
            Apply Now
          </Button>
        </motion.div>}
    </AnimatePresence>;
};